import { createSlice } from "@reduxjs/toolkit";

const awbSlice = createSlice({
  name: "awb",
  initialState: {
    awbNumber: null,
  },
  reducers: {
    setAwbNumberStore: (state, action) => {
      console.log("awbno",state,action.payload)
      state.awbNumber = action.payload ;
    },
    clearAwbNumberStore: (state) => {
      state.awbNumber = null;
    },
  },
});

export const { setAwbNumberStore, clearAwbNumberStore } = awbSlice.actions;
export const selectStoredAwbNumber = (state) => state.awb.awbNumber;
export default awbSlice.reducer;
